window.Lemonade = window.Lemonade || {};

// Global selectors and values
Lemonade.cacheSelectors = function(){

	Lemonade.cache = {

		// General
		$win: $(window),
		$body: $('body'),
		$back_to_top: $('#back-to-top'),

		// Header & Nav
		$header: $('#site-header'),
		$mobileMenu: $('#mobile-menu'),

		// Cart
		$addToCartBtn: $('form[action^="/cart/add"] :submit'),
		$cartCount: $('.cart-count'),
		$cart_flyout: $('#cart-flyout')

	};

};

// Kick off functions
Lemonade.init = function(){
	Lemonade.cacheSelectors();
	Lemonade.windowEvents();
	//Lemonade.windowState();
	Lemonade.animateIn();
	//Lemonade.globalHeader();
	//Lemonade.utilityToggle();
	//Lemonade.openMobileMenu();
	//Lemonade.closeMobileClick();
	Lemonade.accordion();
	
// 	Lemonade.slick();
	//Lemonade.backToTop();
	Lemonade.sizeGuide();
	Lemonade.shippingReturns();
	Lemonade.productHover();
	Lemonade.ajaxSubmit();
	
	Lemonade.productZoom();
	
	Lemonade.productSwap();
	Lemonade.customSelects();
	Lemonade.productQuantity();
	Lemonade.multiplayer();
	Lemonade.collectionControls();
	Lemonade.collectionToggleCols();
	Lemonade.sizeHomeModule();
	
// 	  Lemonade.enableAjax();
  
//   Lemonade.initCartFlyout();
};

// Return window width
Lemonade.windowWidth = function(){
  return $(window).width();
};

// Return window scrollTop
Lemonade.windowScrollTop = function(){
	return $(window).scrollTop();
};

// Window events
Lemonade.windowEvents = function(){

	Lemonade.cache.$win.on({
		load: function(){
		},
		resize: function(){
			Lemonade.windowWidth();
		},
		scroll: function(){
			Lemonade.windowScrollTop();
			//Lemonade.showBackToTop();
		}
	});

};

// READY FOR USE !!!!!!
// Fire a function only when crossing the wide/narrow screen threshold
Lemonade.windowState = function(){

	var state,winState;

	winState = function() {
  	win_width = Lemonade.windowWidth();
		if(win_width > 1023){
			if (state != 'desktop') {
				state = 'desktop';
				changedstate(state);
// 				console.log('desktop');
			};
		} else {
			if (state != 'mobile') {
				state = 'mobile';
				changedstate(state);
// 				console.log('mobile');
			};
		}
	}

	function changedstate(mystate){
	  if(mystate == 'desktop'){
			// Do wide screen stuff here
	  } else {
		  // Do narrow screen stuff here
	  }
	}

	winState();

	$(window).resize(function(){
		winState();
	});

};

// Body no scroll
Lemonade.noScroll = function(){
	Lemonade.cache.$body.addClass('no-scroll');
};

// Body yes scroll
Lemonade.yesScroll = function(){
	Lemonade.cache.$body.removeClass('no-scroll');
};

// READY FOR USE !!!!!!
// Library dependancy https://github.com/protonet/jquery.inview
// Animate Elements when inview
Lemonade.animateIn = function(){

	$('.animate-in').on('inview', function(event, isInView) {
	  if (isInView) {
	    $(this).addClass('in-view');
	  } else {
	    $(this).removeClass('in-view');
	  }
	});

};

// Site Header + Navigation
/*
Lemonade.globalHeader = function(){

	// init settings and selectors
	var $window = $(window),
			$body = $('body'),
	    $header = $('#site-header'),
	    $site_bar = $('#site-bar'),
	    $main_content = $('.main-content'),
	    $mega_trigger = $('.site-nav').find('.has-dropdown'),
	    $mega_menu_container = $('#mega-menu-container'),
	    $mega_menu = $('.mega-menu'),
	    $mobile_menu = $('#mobile-menu'),
	    header_height,
	    bar_height,
	    total_offset,
	    speed = 200,
 	    $me_menu = null,
	    openTimer,
	    closeTimer,
	    intentTimer,
	    $tp = $('.transition-point'),
	    win_pos,
	    len = $tp.length,
	    tp_pos,
	    header_specs,
	    state,
	    winState;

	//-- FUNCTIONS ---//

	// Check state of window width (wide vs narrow screen)
	var winState = function() {
  	win_width = $(window).width();
		if(win_width > 1023){
			if (state != 'desktop') {
				state = 'desktop';
				changedstate(state);
				console.log('desktop');
			};
		} else {
			if (state != 'mobile') {
				state = 'mobile';
				changedstate(state);
				console.log('mobile');
			};
		}
	}

  // If/When window crosses the wide/narrow threshold you can do some stuff here
	function changedstate(mystate){
	  if(mystate == 'desktop'){
			// Do wide screen stuff here
			// Close mobile menu if going to wide screen
		  closeMobileMenu();
	  } else {
		  // Do narrow screen stuff here
	  }
	}

	// Loops through a standard Shopify menu/submenu structure and pulls the sub menus out of their parent-child DOM relationship and
	// appends them to a designated wrapper div just outside the #site-header. This allows the use nested menu building in the admin while
	// providing some frontend flexibility
	function buildMegaMenus(){
		// target the class applied to any parent menu item with a submenu associated with it
		$('.has-dropdown').each(function(i,el){
			// reference to each one during loop iteration
			$me = $(el);
			// grab the submenu of each
			$me_sub = $me.find('.site-nav-dropdown');
			// append that sub menu to the placeholder div already created in the DOM
			$mega_menu_container.append($me_sub);
		});
	}

	// Close the submenu and reset everything (see headerResets function for more detail)
	function closeMenu($me){
		// create a timeout to offset the timing of the submenu closing
		closeTimer = setTimeout(function(){
			// remove the active class from the trigger
			$me.removeClass('activated');
			// remove the open class applied to the site-header
			$header.removeClass('menu-open');
			// fadeOut the active menu
			$mega_menu.fadeOut(function(){
				// after menu has faded out call the headerResets() for more resetting
				headerResets()
			});
		}, speed);
	}

	// Open the submenu
	function openMenu($me){
		// menu not already open
		if(!openTimer) {
			// create a timeout to offset the timing of sub menu opening
	    openTimer = window.setTimeout(function() {
        timeoutId = null;
        // Grab the data attribute value off of the currently selected trigger.
        // This value matches the ID of the correlating submenu
        this_menu = $me.data('mega-menu');
        // Create selector from this attribute value
				$me_menu = $('#'+this_menu);
				// Get the height of the submenu to be opened
				me_menu_height = $me_menu.height();
				// Activate the current trigger and deactivate the others
				$me.stop().addClass('activated').siblings().removeClass('activated');
				// Stop closing of submenus
				clearTimeout(closeTimer);
				// Add open class to site-header
				$header.addClass('menu-open');
				// fadeOut any open Mega menus in preperation for the current one to be opened
				$me_menu.siblings('.mega-menu').fadeOut(function(){
					// this function does some calculations to open the submenus appropriately (see function for more detail)
					headerOffsets(me_menu_height, false);
					$mega_menu_container.addClass('open');
					// Fade in the current mega menu with a little delay
					setTimeout(function(){
						$me_menu.fadeIn();
					}, 300)
				});
			}, speed);
 		}
	}

	// Open/Close submenu depending
  function toggleMenu(new_trigger, old_trigger){
    openMenu(new_trigger);
    closeMenu(old_trigger);
	}

  // Return an object of header specs/dimensions
  function headerCalcs(){

	  
		  total_offset = $header.height() + $site_bar.outerHeight();
		

	  header_specs = {
		  header_height: $header.height(),
		  bar_height: $site_bar.outerHeight(),
		  header_plus_bar: $header.height() + $site_bar.outerHeight(),
		  total_offset: total_offset
	  };

	  return header_specs;

  }

  // This function handles all the logic for determing offset positioning of elements affected by
  // sticky header, global promo bar and scrolled state of site header
  // takes 3 arguments: height of the sub menu being opened and true/false if first init on window.load.
	function headerOffsets(heighty, init){

		var h,t,p;

		// get the current header specs/dimensions
		headerCalcs();

		// Push the site header down from under the fixed promo bar
		$header.css('top', header_specs.bar_height);

		// Push the page content down from under the fixed header/fixed header + fixed promo bar
		$main_content.css('padding-top', header_specs.total_offset);

		// If function is being called from within openMenu function set styles accordingly
		// These are ignored in the first init of headerOffsets()
		if(!init){
			// If scrolled past the header should have a color filled bg. In this case the mega menus can be pushed down to the bottom of the header
			if($header.hasClass('scrolled-past')){
				// set the height of the current mega menu + a little extra cushioning. Flex css will handle the centering of the elements in the menu.
				// offset the mega menu to be below the header
				// Since mega menu starts at the bottom of site header no paddingTop required
				h = heighty + 40;
				t = header_specs.header_plus_bar;
				p = 0;
			} else {
				// set the height of the current mega menu + a little extra cushioning. Flex css will handle the centering of the elements in the menu.
				// In this case the site header should still be transparent. Mega Menus are never transparent so instead of animating the header bg color simultaneously
				// with the animating of the mega menu (this would look like crap), we will simply set the mega menu behind the site header with enough paddingTop to push
				// menu elements down below header elements. This allows for one seemless animation to bring both the site header and mega menu onto a white bg.
				h = heighty + 120;
				t = header_specs.bar_height;
				p = header_specs.header_height;
			}

			$mega_menu_container.css({
				height: h,
				top: t,
				paddingTop: p
			});

		}
	}

	// Reset Mega Menus height and paddingTop to 0
	function headerResets(){
		$mega_menu_container.css({
			height: 0,
			paddingTop: 0
		}).removeClass('open');
	}

	// Header transition on scroll
	var transitionPoint = function(){

		// get the current header specs/dimensions
		headerCalcs();

		// get window scroll position
		win_pos = $window.scrollTop();

		// if transition point trigger exists in the DOM continue
		if(len > 0){
			// get the offset of the transition point trigger
		  tp_pos = $tp.offset().top;
		  // if scrolled beyond transition point do stuff
			if(win_pos > (tp_pos - 400)){
				if(!$header.hasClass('scrolled-past')){
					$header.addClass('scrolled-past');
					$mega_menu_container.css({
						top: header_specs.header_plus_bar
					});
				}
			} else {
				if($header.hasClass('scrolled-past')){
					$header.removeClass('scrolled-past');
					$mega_menu_container.css({
						top: header_specs.bar_height
					});
				}
			}
		}
	};

	// Close the mobile menu
	var closeMobileMenu = function(){
		if($mobile_menu.hasClass('show-menu')){
			$mobile_menu.removeClass('show-menu');
			$body.removeClass('no-scroll');
		}
	};

	//-- EVENTS AND FUNCTION CALLS ---//
	$mega_trigger.on({
		mouseenter: function(){
			$me = $(this);
			var old_trigger = Lemonade.cache.old_trigger;
      var new_trigger = Lemonade.cache.old_trigger = $me;
      if(!new_trigger.hasClass('has-dropdown')) {
        window.clearTimeout(openTimer);
        openTimer = null;
        Lemonade.cache.old_trigger = false;
        closeMenu($me);
      } else if(old_trigger == false) {
        openMenu(new_trigger);
      } else if(new_trigger != old_trigger) {
        intentTimer = window.setTimeout(function(){
          window.clearTimeout(openTimer);
          openTimer = null;
          toggleMenu(new_trigger, old_trigger);
        }, 300);
      }
		},
		mouseleave: function(){
		  window.clearTimeout(intentTimer);
		  intentTimer = null;
		}
	});

	$mega_menu_container.on({
		mouseenter: function(){
      window.clearTimeout(intentTimer);
      intentTimer = null;
		},
		mouseleave: function(){
		  window.clearTimeout(openTimer);
		  openTimer = null;
			closeMenu($me);
			Lemonade.cache.old_trigger = false;
		}
	});

	// Open the mobile menu
	$('#btn-mobile-menu').click(function(){
		if(!$mobile_menu.hasClass('show-menu')){
			$mobile_menu.addClass('show-menu');
			$body.addClass('no-scroll');
		}
	});

	// Close the mobile menu
	$('.close-mobile').click(closeMobileMenu);

	buildMegaMenus();

	headerOffsets(0, true);

	transitionPoint();

	winState();

	$window.on({
		scroll: function(){
			transitionPoint();
		},
		resize: function(){
			headerOffsets(0, false);
			winState();
		}
	});

};
*/


// Mega Menus (Original)
/*
Lemonade.megaMenu = function(){

	var $mega_trigger = $('.site-nav').find('li'),
	    $mega_menu = $('.mega-menu'),
	    speed = 200,
	    $me_panel = null,
	    openTimer,
	    closeTimer;

	function closeShop(){
		closeTimer = setTimeout(function(){
			$me.removeClass('activated');
			$('.mega-menu').removeClass('show');
			Lemonade.cache.$header.removeClass('menu-open');
		}, speed);
	}

	$mega_trigger.on({
		mouseenter: function(){
			$me = $(this);
			if(!openTimer) {
        openTimer = window.setTimeout(function() {
	        timeoutId = null;
					me_data = $me.data('mega-trigger');
					$me_panel = $('#'+me_data);
					$me.stop().addClass('activated').siblings().removeClass('activated');
					if($me_panel.length > 0){
						clearTimeout(closeTimer);
						Lemonade.cache.$header.addClass('menu-open');
						$me_panel.addClass('show').siblings('.mega-menu').removeClass('show');
					} else {
						closeShop();
					}
				}, speed);
			}

		},
		mouseleave: function(){
			$me = $(this);
			if (openTimer) {
        window.clearTimeout(openTimer);
        openTimer = null;
        closeShop();
      }
		}
	});

	$mega_menu.on({
		mouseenter: function(){
			clearTimeout(closeTimer);
		},
		mouseleave: function(){
			closeShop();
		}
	});
};
*/

// Utility toggle
Lemonade.utilityToggle = function(){
	var $utility_trigger = $('.utility-trigger');

	$utility_trigger.click(function(){
		$me = $(this);

		$me.siblings().removeClass('active');
		$('.utility-item').removeClass('show');

		if($me.hasClass('active')){
			$me.removeClass('active');
			$me_item = $me.data('header-utility');
			$('#'+$me_item).removeClass('show');

		} else {
			$me.addClass('active');
			$me_item = $me.data('header-utility');
			$('#'+$me_item).addClass('show');
		}
	});
};

// Open the mobile menu
Lemonade.openMobileMenu = function(){
	$('#btn-mobile-menu').click(function(){
		if(!Lemonade.cache.$mobileMenu.hasClass('show-menu')){
			Lemonade.cache.$mobileMenu.addClass('show-menu');
			Lemonade.noScroll();
		}
	});
};

// Close the mobile menu
Lemonade.closeMobileMenu = function(){
	if(Lemonade.cache.$mobileMenu.hasClass('show-menu')){
		Lemonade.cache.$mobileMenu.removeClass('show-menu');
		Lemonade.yesScroll();
	}
};

// Close mobile menu click event
Lemonade.closeMobileClick = function(){
	$('.close-mobile').click(Lemonade.closeMobileMenu);
};

// Content accordions
Lemonade.accordion = function(){

  var $accTrigger = $('.acc-trigger'),
      $acc = $('.acc-content');

  // accordian content
  $accTrigger.click(function(e){
	  e.preventDefault();
    var $me = $(this),
        $content = $me.next('.acc-content');

    $acc.slideUp();
    if($me.hasClass('open')){
      $me.removeClass('open');
      return false;
    }
    $accTrigger.removeClass('open');
    $me.addClass('open');
    $content.slideToggle();
  });

};

// Popup Newsletter
Lemonade.popup = function(){

	function newsletterPopup(){
    $.fancybox.open([{
	    'width': 628,
			'height': 399,
			'autoSize' : false,
	    'href': '#newsletter-popup'
    }], {
	    padding: 0
    });
	}

  if (typeof $.cookie('newsletter-modal') === 'undefined') {
    $.cookie('newsletter-modal', '1', { expires: 30, path: '/' });
    setTimeout(function(){
			newsletterPopup();
		}, 3000);
	}


  $('.newsletter-trigger').click(function(){
	  newsletterPopup();
  });

};

// // Slick init
// Lemonade.slick = function(){

// 	var $slick = $('.slick');

// 	$slick.on('init', function(){
// 		Lemonade.slickAlignArrows();
// 	});

// 	$slick.slick();
// };

// // Slick carousel vertically align prev/next arrows to carousel item image
// Lemonade.slickAlignArrows = function(){

// 	setTimeout(function(){

// 		$('.slider-wrap').each(function(i, el){
// 			$me = $(el);
// 			if($me.hasClass('carousel')){
// 				img_height = $me.find('.slick-slide').first().find('img').first().height() / 2;
// 			  $me.find('.slick-arrow').css({'top': img_height});
// 			} else {
// 				$('.slide-arrow').addClass('init');
// 			}

// 		});
// 	}, 500);

// };

// Show Back to top
Lemonade.showBackToTop = function(){
	var grid_pos = $('.grid-wrapper').offset().top;
	if(Lemonade.windowScrollTop() > grid_pos){
		Lemonade.cache.$back_to_top.fadeIn();
	} else {
		Lemonade.cache.$back_to_top.fadeOut();
	}
};

// Back to top
Lemonade.backToTop = function(){
	Lemonade.cache.$back_to_top.click(function(){
		Lemonade.cache.$body.animate({'scrollTop': 0});
	});
};

// Size guide popup
Lemonade.sizeGuide = function(){

	$('.sizeguide-trigger').click(function(){

		$.fancybox.open([{
			width: 800,
			height: 400,
			autoSize: false,
			href: '#sizeguide'
		}], {
			padding: 30
		});

	});

};

// Size guide popup
Lemonade.shippingReturns = function(){

	$('.shipping-returns-trigger').click(function(){

		$.fancybox.open([{
			width: 800,
			height: 400,
			autoSize: false,
			href: '#shipping-returns'
		}], {
			padding: 30
		});

	});

};

// Product grid hover photo
Lemonade.productHover = function(){

	var speed = 200;

	$('.item-image').on({
		mouseenter: function(){
			$me = $(this);
			$me_hover_img = $me.find('.hover-img');

			if($me_hover_img.length > 0){
				$me_hover_img.stop().fadeIn(speed);
				//$me.find('img').first().stop().fadeOut(speed);
			}
		},
		click: function(){
			$me = $(this);
			$me_hover_img = $me.find('.hover-img');

			if($me_hover_img.length > 0){
				$me_hover_img.stop().fadeIn(speed);
				//$me.find('img').first().stop().fadeOut(speed);
			}
		},
		mouseleave: function(){
			$me = $(this);
			$me_hover_img = $me.find('.hover-img');

			if($me_hover_img.length > 0){
				$me.find('.hover-img').stop().fadeOut(speed);
				$me.find('img').first().stop().fadeIn(speed);
			}
		}
	});

};

// Mailchimp Ajax submit
Lemonade.ajaxSubmit = function(){

  var $form = $('.mailchimp-form');

  $('.mailchimp-form .btn').on('click', function(event) {
		if(event) event.preventDefault();
		var form = $(this).closest('.mailchimp-form');
    register($form, form);
  });

	function register($form, form) {
	  $.ajax({
	    type: $(form).attr('method'),
	    url: $(form).attr('action'),
	    data: $(form).serialize(),
	    cache       : false,
	    dataType    : 'json',
	    contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
						$(form).find('.success').html(data.msg).fadeIn();
        } else {
            // It worked, carry on...
            $(form).find('.success').html('Sign up for free shipping on your first order').fadeIn();
        }
      }
	  });
	}

};

// Product Zoom

Lemonade.productZoom = function(){
	

		$('#product-image').click(function(){

			if($('.zoomContainer').length < 1){
				$(".zoom").elevateZoom({
					zoomType: "inner",
				  cursor: "crosshair"
				});
			}

			$('.zoomContainer').click(function(){
				$(this).remove();
			});

		});

	
};


// Product thumb swap
Lemonade.productSwap = function(){

	$main_photo = $('#product-image').find('img');

	$('#product-thumbs').find('a').on({
		mouseenter: function(){
			me = $(this);
			new_pic = me.attr('href');
			new_zoom = new_pic.replace("1024x1024", "2048x2048");
			$('#product-thumbs a').removeClass('over');
			$(this).addClass('over');
			$('.zoomContainer').remove();

			$main_photo.attr('src', new_pic).data('zoom-image', new_zoom);
		},
		click: function(e){
			me = $(this);
			new_pic = me.attr('href');
			new_zoom = new_pic.replace("1024x1024", "2048x2048");
			$('#product-thumbs a').removeClass('over');
			$(this).addClass('over');
			$('.zoomContainer').remove();

			$main_photo.attr('src', new_pic).data('zoom-image', new_zoom);
			e.preventDefault();
		}
	});

};

Lemonade.sizeHomeModule = function(){
	/*
	if($('.section-home-module .article-module').length > 0){
		var img_height = $('.section-home-module .product-module').find('img').first().height();
		console.log('set image height ' + img_height)
		$('.section-home-module .article-module').find('img').css('height', img_height);
	}
	*/
}

// Product custom selects
Lemonade.customSelects = function(){

	function urlescape(str){
		var new_str = str.replace(/[^a-zA-Z ]/g, "");
		return new_str;
	}

	$('.selector-wrapper').each(function(){
		var $selectWrap = $(this),
			$prod_variants = $selectWrap.find('.single-option-selector'),
			$label = $selectWrap.find('label'),
	    $options = $selectWrap.find('option'),
	    $dummy = $('<ul class="dummy-select" data-dummy-variant="'+ $label.text() +'"></ul>'),
			$selection = $('<div class="selection label">'+$label.text()+'<span class="label-option-selected"></span></div>');

			// wipe clean the selector on each color change
			$selectWrap.find('ul, .selection').remove();

			// build options in dummy select dropdown with data-attributes derived from real select
			if($options.length == 1) {
				$dummy.addClass('single-option-dummy');
			}
			$options.each(function(i, el){
				$el = $(el);
				qty = $el.data('qty');
				name = $el.data('variant-title');
				color = urlescape($el.val().toLowerCase()).split(' ').join('-');
				text = $el.text();
				if($label.text() == 'Size') {
					if($.isNumeric(text)){
						text = text + '"';
					}
				}
				$dummy.append('<li class="'+color+'" data-val="'+$el.val()+'" data-qty="'+qty+'" data-variant-title="'+name+'">'+text+'<span class="icon icon-arrow"><svg><use xlink:href="#icon-down"></use></svg></span></li>');
			});
			$selectWrap.prepend($dummy);
			$selectWrap.prepend($selection);
			$label.add($prod_variants).hide();

			// click evens on variant select
			$selectWrap.find('.dummy-select li').on('click', function(e){
				$me = $(this);
				$dummy = $me.parent();
				if($me.hasClass('active')) {
					e.stopPropagation();
					$dummy.addClass('active');
					return true;
				} else {
					$dummy.removeClass('active');
				}

				me_qty = $me.data('qty');
				value = $me.data('val');
				var_name = $me.data('variant-title')
				text = $me.text();
				$selection.removeClass('show');
				$selection.find('.label-option-selected').text(text);
				$me.closest('.selector-wrapper').find('.single-option-selector').find('option[value="'+value+'"]').prop('selected', true);
				$me.closest('.selector-wrapper').find('.single-option-selector').trigger('change');
				if(!$me.hasClass('active')){
					$me.addClass('active').siblings('li').removeClass('active');
				}
			})




			$prod_variants.on('change', function(){
				var val = $(this).val(),
						$selectWrap = $(this).closest('.selector-wrapper'),
						$dummy = $selectWrap.find('.dummy-select');

						$dummy.find('li').removeClass('active');
						$dummy.find('li[data-val="'+ val +'"]').addClass('active');

						$selectWrap.find('.label-option-selected').text($selectWrap.find('select').val());

						setTimeout(function(){
							var variant_img = $('#productSelect option:selected').attr('data-variant-image');

							$('#product-image img').attr('src', variant_img).data('zoom-image', variant_img);
							$('.zoomContainer').remove();
						})


// 						console.log(val);
			});

			$prod_variants.trigger('change');

			$('body').on('click', function(e){
				$('.dummy-select').removeClass('active');
			});

	});







    //$dummy.stop().slideUp(250);
    //$prod_variants.val(value).trigger('change');

    // show qty message if less than 4 available
    //inventory_message(me_qty);

    // toggle add to cart and waitlist btn depending on product availability
/*
    if($me.data('qty') < 1){
	    $Qty.val(0);
	    $wait_btn.show();
	    $psuedo_add.hide();
    } else {
	    $Qty.val(1);
	    $wait_btn.hide();
	    $psuedo_add.show();
    }
*/


  // open/collapse variant select accordion
/*
  $selection.click(function(){
    $selectWrap = $(this);
    $selectWrap.toggleClass('show');
    $dummy.stop().slideToggle(250);
  });
*/

};

// Custom product quantity
Lemonade.productQuantity = function(){

  $(".qty").find('span').on("click", function() {

	  var $button = $(this);
	  var oldValue = $('#Quantity').val();

	  if ($button.hasClass('up')) {
		  var newVal = parseFloat(oldValue) + 1;
		} else {
	   // Don't allow decrementing below one
	    if (oldValue > 0) {
	      var newVal = parseFloat(oldValue) - 1;
	    } else {
	      newVal = 0;
	    }
	  }

	  $('#Quantity').val(newVal);

	});

};

// Multiplayer
Lemonade.multiplayer = function(){

	$('.trigger').click(function(){
		me = $(this);
		me_panel = me.data('panel');

		if(!me.hasClass('active')){
			me.addClass('active').siblings('.trigger').removeClass('active');
			$me_panel = $('#'+me_panel);

			$me_panel.siblings('.panel').removeClass('active');
			setTimeout(function(){
				$('#'+me_panel).addClass('active')
			}, 350);
		}

	});

};

// Collection Sorting/Filtering
Lemonade.collectionControls = function(){

	speed = 200;

	$('.fake-select').find('span').click(function(){
		$me = $(this);

		if($me.hasClass('open')){
			$me.removeClass('open').next('ul').fadeOut(speed);
		} else {
			$('.fake-select').find('span').removeClass('open').next('ul').fadeOut(speed);
			$me.addClass('open').next('ul').fadeIn(speed);
		}
	});

};

// Collection grid toggle
Lemonade.collectionToggleCols = function(){

	var $collection_grid = $('.grid-wrapper');

	$('.toggle-cols').find('span').click(function(){
		$me = $(this);
		if($me.hasClass('active') == false){
			$me.addClass('active').siblings('.icon').removeClass('active');
		  if($me.hasClass('icon-two-col')){
			  $collection_grid.animate({'opacity': 0}, 250, function(){
				  $collection_grid.addClass('two-col');
					setTimeout(function(){
						$collection_grid.animate({'opacity': 1});
					}, 400);
			  });
		  } else {
			  $collection_grid.animate({'opacity': 0}, 250, function(){
					$collection_grid.removeClass('two-col');
					setTimeout(function(){
						$collection_grid.animate({'opacity': 1});
					}, 400);
				});
		  }
	  }
  });

};

// Product Page
Lemonade.productPage = function(options){
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      translations = options.translations;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      //Shopify.Image.switchImage(newImg, el, lemonade.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(translations.add_to_cart);
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(translations.sold_out);
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
		$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $quantityElements.hide();
  }
};

// Add to cart button states
Lemonade.addToCartflip = function($addToCartBtn){

	return true;
  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to Cart";

  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
    .clone(true)
    .prop('disabled', false)
    .removeClass('disabled')
    .addClass('btn--unflipped')
    .find('span')
    .text(addToCartText)
    .end()
    .hide()
    .insertAfter($addToCartBtn);

  $addToCartBtn
    .unbind('click')
    .removeClass('disabled')
    .find('span')
    .text("View cart")
    .end()
    .bind('click', function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    })
    .prop('disabled', false)
		.addClass('btn--flipped')

	
		$('.product-bag-actions').after('<span class="continue-shopping"> <a class="btn--secondary" href="/collections/all">Continue shopping</a></span>');
	
  $('.continue-shopping a').bind('click', Lemonade.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

// Ajax submit add to cart

Lemonade.enableAjax = function() {
//   Lemonade.cache.$addToCartBtn.bind('click', function(e) {
//     e.preventDefault();
//     $('.note.errors').remove();
//     var $addToCartBtn = $(this),
//         $addToCartForm = $(this).closest('form'),
//         $addToCartBtnText = $(this).find('span');
//     if ($addToCartForm.length) {
//       $addToCartBtn
//         .attr('data-add-to-cart', $addToCartBtnText.text())
//         .prop('disabled', true)
//         .addClass('disabled')
//         .addClass('btn--loading');
//       $.ajax({
//         url: '/cart/add.js',
//         dataType: 'json',
//         type: 'post',
//         data: $addToCartForm.serialize(),
//         success: function(lineItem) {
//           $.getJSON('/cart.js', function(cart) {
//             Lemonade.cache.$cartCount.text(cart.item_count);
//             $('.hidden-count').removeClass('hidden-count');
//           });
//           $addToCartBtn.removeClass('btn--loading');
//           Lemonade.addToCartflip($addToCartBtn);
//         },
//         error: function(XMLHttpRequest, textStatus) {
//           var data = eval('(' + XMLHttpRequest.responseText + ')');
//           var response = data.description;
//           var status = XMLHttpRequest.status;
//           $addToCartBtn.removeClass('btn--loading');
//           if (status === 422 && $('#productSelect option').length === 1) {
//             $addToCartBtnText.text("Coming soon, notify me");
//           }
//           else {
//             $addToCartBtn.prop('disabled', false).removeClass('disabled');
//             $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
//           }
//           $addToCartBtn.after('<p class="note errors app.js#1263">' + response + '</p>');
//         }
//       });
//     }
//   });
};


Lemonade.initCartFlyout = function() {
  var $cartFlyout = $('#cart-flyout'),
      $cartTrigger = $('#cart-trigger'),
      $addToCartBtn = $('form[action^="/cart/add"] :submit'),
  	  $closeCartBtn = $('.cart-close');

  getCartJSON(renderCartFlyout, false);
  resizeCartFlyout();

  function getCartJSON(callback, show_flyout) {
    $.getJSON('/cart.js', function(cart) {
      if (typeof callback !== undefined) {
        callback(cart, show_flyout);
      }
    })
  }

  function renderCartFlyout(cart, show_flyout){
    cart.item_count === 0 ? $cartFlyout.addClass('empty') : $cartFlyout.removeClass('empty');

    $('.cart-nav-count').text(cart.item_count);
    // show cart flyout
    var source = $("#cart-template").html(),
        template = Handlebars.compile(source),
        items = [],
        total = 0,
        total_qty = 0,
        img_small;


    $.each(cart.items, function(i,o){
      img_small = o.image ? o.image.replace(/^(.+)(\..+)$/, '$1_small$2') : '';
      items.push({
        id: o.id,
        vendor: o.vendor,
        title: o.product_title,
        url: o.url,
        qty: o.quantity,
        price: Shopify.formatMoney(o.discounted_price),
        image: img_small,
        variant_options: o.variant_options,
        classes: (o.discounted_price) ? '' : 'free-item'
      });
    });

    $('.summary span', Lemonade.cache.$cart_flyout).html( Shopify.formatMoney( cart.total_price ) );
    $('.products', $cartFlyout).html( template({items:items}) );

    if (show_flyout) {
      showCartFlyout();
    }

    // Check whether to show donation field
    const donations = document.getElementById('donations')
    const itemTitles = cart.items.map(item => item.product_title.toLowerCase())
    if (itemTitles.some(title => title.includes('penn state') || title.includes('thon'))) donations.classList.add('is-active')
    else donations.classList.remove('is-active')
  }

  function showCartFlyout() {
    $cartFlyout.addClass('show');
  }

  function hideCartFlyout() {
    $cartFlyout.removeClass('show');
  }

  function addToCart(e) {
    e.preventDefault();
    $('.note.errors').remove();

    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span'),
    	$productBagActions = $('.product-bag-actions');

    if ($addToCartForm.length) {
      $addToCartBtn.attr('data-add-to-cart', $addToCartBtnText.text()).prop('disabled', true).addClass('disabled btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
          $addToCartBtn.removeClass('btn--loading').prop('disabled', false).removeClass('disabled btn--loading');
          setTimeout(function(){
            getCartJSON(renderCartFlyout, true);
          })
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Coming soon, notify me");
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $productBagActions.after('<p class="note errors app.js#1371">' + response + '</p>');
        }
      });
    }
  };

  function updateQuantity(el) {
    var $button = $(el),
        $qty = $button.parent().find('.quantity'),
        oldQty = $qty.val(),
        variant_id = $qty.data('variant');

    if ($button.hasClass('up')) {
        var newQty = parseFloat(oldQty) + 1;
      } else {
      if (oldQty > 0) {
        var newQty = parseFloat(oldQty) - 1;
      } else {
        newQty = 0;
      }
    }

    $qty.attr('value', newQty);
    updateCart(variant_id, newQty);
  }

  function updateCart(variant_id, quantity){
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity='+quantity+'&id='+variant_id,
      dataType: 'json',
      success: function(cart) {
				Lemonade.cache.$cartCount.text(cart.item_count);
        renderCartFlyout(cart, true);
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };

    $.ajax(params);
  }

  function resizeCartFlyout() {
    $('.products', $cartFlyout).css({
      height: (Lemonade.cache.$win.outerHeight() - ($('#site-bar').outerHeight() + $('#site-header').outerHeight()) - $('.summary', $cartFlyout).outerHeight() - 92) // height of title in cart flyout
    });
  }

  $cartFlyout.on('click', '.qty span', function() {
    updateQuantity(this);
	});

	$cartFlyout.on('click', '.remove', function(e){
		e.preventDefault();
		var variant_id = $(this).data('variant-id');
		updateCart(variant_id, 0);
	});

  $addToCartBtn.on('click', addToCart);
  $closeCartBtn.on('click', hideCartFlyout);


  Lemonade.cache.$win.on('resize', function(){
    resizeCartFlyout();
  });

  Lemonade.cache.$body.on('click', function(e){
    if ( $(e.target).attr('id') == 'cart-trigger' ) {
      $cartFlyout.toggleClass('show');
    } else {
      if ( !$(e.target).closest($cartFlyout).length ) {
        $cartFlyout.removeClass('show');
      }
    }
  });

  return {
    renderCartFlyout: renderCartFlyout,
    showCartFlyout: showCartFlyout,
    hideCartFlyout: hideCartFlyout,
    addToCart: addToCart
  }
};

// Initialize Lemonade JS on docready
$(Lemonade.init);

// Add Donation attribute to cart
async function addDonationAttribute () {
  	const status = document.getElementById('donation-status')
	const organization = document.getElementById('donation-organization').value
    if (!organization) return
    const attributes = {
      'Donation Organization': organization
    }
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({ attributes })
	})
    if (res.ok && res.status === 200) {
      status.innerText = `Your donation will go to ${organization}.`
    } else {
      status.innerText = 'Something went wrong - please try again.'
    }
}

// Create Alpine state
// Simple state object & helpers
function state () {
  return {
    loading: false,
    error: '',
    success: '',
    reset () {
      this.loading = false
      this.error = false
      this.success = ''
    },
    setLoading (loading = true) {
      this.reset()
      this.loading = loading
    },
    setError (error) {
      this.reset()
      this.error = error
      setTimeout(() => this.reset(), 4000)
    },
    setSuccess () {
      this.reset()
      this.success =  true
      setTimeout(() => this.reset(), 2000)
    }
  }
}


const emblaHelpers = {
	addDotBtnsAndClickHandlers: ( emblaApi ) => {
		const dotsNode = emblaApi.rootNode().parentElement.querySelector( '.embla-dots' )
		let dotNodes = []

		const addDotBtnsWithClickHandlers = () => {
			dotsNode.innerHTML = emblaApi
				.scrollSnapList()
				.map( () => '<button class="embla-dot" type="button"></button>' )
				.join( '' )

			dotNodes = Array.from( dotsNode.querySelectorAll( '.embla-dot' ) )
			dotNodes.forEach( ( dotNode, index ) => {
				dotNode.addEventListener( 'click', () => emblaApi.scrollTo( index ), false )
			} )
		}

		const toggleDotBtnsActive = () => {
			const previous = emblaApi.previousScrollSnap()
			const selected = emblaApi.selectedScrollSnap()
      if ( dotNodes[previous] ) dotNodes[previous].classList.remove( 'active')
      if ( dotNodes[selected] ) dotNodes[selected].classList.add( 'active')
		}

		emblaApi
			.on( 'init', addDotBtnsWithClickHandlers )
			.on( 'reInit', addDotBtnsWithClickHandlers )
			.on( 'init', toggleDotBtnsActive )
			.on( 'reInit', toggleDotBtnsActive )
			.on( 'select', toggleDotBtnsActive )

		return () => {
			dotsNode.innerHTML = ''
		}
	}
}
